export const PIECE_DEFAULT_GRAMS = 50;

export interface IngredientLike {
  default_unit_weight_g: number | null;
  kcal_per_100: number;
  protein_per_100: number;
  carbs_per_100: number;
  fat_per_100: number;
}

export function unitToGramsFactor(unit: string, ingredient?: IngredientLike | null): number {
  const u = unit.toLowerCase();
  switch (u) {
    case 'g':
    case 'ml':
      return 1;
    case 'tbsp':
      return 15;
    case 'tsp':
      return 5;
    case 'pcs':
    case 'piece':
      return ingredient?.default_unit_weight_g ?? PIECE_DEFAULT_GRAMS;
    default:
      return 1;
  }
}

export interface Macros {
  kcal: number;
  protein_g: number;
  carbs_g: number;
  fat_g: number;
}

export interface LineInput {
  amount: number;
  unit: string;
  ingredient: IngredientLike;
}

export function computeLineMacros(line: LineInput): Macros {
  const factor = unitToGramsFactor(line.unit, line.ingredient);
  const k = (line.amount / 100) * factor;
  const i = line.ingredient;
  return {
    kcal: k * i.kcal_per_100,
    protein_g: k * i.protein_per_100,
    carbs_g: k * i.carbs_per_100,
    fat_g: k * i.fat_per_100,
  };
}

export function computePerPortionMacros(portions: number, lines: LineInput[]): Macros {
  const total: Macros = { kcal: 0, protein_g: 0, carbs_g: 0, fat_g: 0 };
  for (const line of lines) {
    const m = computeLineMacros(line);
    total.kcal += m.kcal;
    total.protein_g += m.protein_g;
    total.carbs_g += m.carbs_g;
    total.fat_g += m.fat_g;
  }
  const safePortions = portions > 0 ? portions : 1;
  return {
    kcal: total.kcal / safePortions,
    protein_g: total.protein_g / safePortions,
    carbs_g: total.carbs_g / safePortions,
    fat_g: total.fat_g / safePortions,
  };
}